import { Location } from 'history';
import queryString from 'query-string';
import { useSelector } from 'react-redux';
import { getRouterState } from '../../../global/selectors';
import { LocationState } from '../../../global/types';
import { defaultSortOrder } from '../constants';
import { PayoutsSortOrder } from '../types';

type PayoutsQueryParams = {
  location: Location<LocationState>;
  locationState: LocationState;
  search: string;
  sortOrder: PayoutsSortOrder;
  start: number;
};

const parsePayoutsSortOrder = (sort: string): PayoutsSortOrder => {
  const sortOrders = Object.values(PayoutsSortOrder);
  return sortOrders.includes(sort as PayoutsSortOrder)
    ? (sort as PayoutsSortOrder)
    : defaultSortOrder;
};

const usePayoutsQueryParams = (): PayoutsQueryParams => {
  const { location } = useSelector(getRouterState);
  const parsed = queryString.parse(location.search);
  const start: number = parsed.start ? parseInt(parsed.start.toString(), 10) : 0;
  const search: string = parsed.search ? parsed.search.toString() : '';
  const sortOrder = parsePayoutsSortOrder(parsed.sort ? parsed.sort.toString() : '');
  const { state } = location;

  return {
    location,
    locationState: state,
    search,
    sortOrder,
    start,
  };
};

export default usePayoutsQueryParams;
